module.exports = __webpack_public_path__ + "img/login_bg.42dd6e16.png";